
import {
  defineComponent,
  ref,
  reactive,
  onBeforeMount,
  watch,
  onMounted,
  nextTick,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { MutationNames, useStore } from "@/store";
import { getMockExamInfo, getMockExamAnswers } from "@/services";
import useMockExam from "@/hooks/useMockExam";
import { t } from "element-plus/lib/locale";
export default defineComponent({
  setup() {
    const store = useStore();
    let account = ref("");
    let questionsData: any = reactive(store.state.freePracticeQuestions); // 所有自由练习作答记录
    let subjectInfo: any = ref(store.state.freePracticeQuestions); // 初始化的时候所有作答记录，只看错题是所有错题记录
    let subjectInfoEight: any = reactive([]);

    let examList = reactive([]);
    let total = ref(1);
    let current_page = ref(1);
    let message = ref("");
    let activeExams = ref([]); // 所有考试基础信息
    let activeExam = ref(""); // 选中考试基础信息
    let isErrorQuestion = ref(false); // 只看错题状态
    const router = useRouter();
    const route = useRoute();
    // 题型
    const questionType: { [key: number]: string } = {
      1: "单选题",
      2: "多选题",
      3: "编创题",
      4: "判断题",
      5: "演唱题",
      6: "演奏题",
      7: "视唱题",
      8: "连线题",
      9: "填空题",
      10: "简答题",
      11: "套题",
      12: "拖拽题",
      13: "色环题",
      14: "拼图题",
    };
    // watch(
    //   () => isErrorQuestion.value,
    //   (newVal) => {
    //     console.log("newVal", newVal);
    //     checkIsErrorQuestion();
    //   }
    // );
    const goBack = () => {
      // router.back();
      router.push({
        path: "/freePractice",
      });
    };

    const checkIsErrorQuestion = () => {
      console.log("check", isErrorQuestion.value);
      console.log("store.state", store.state.freePracticeQuestions);
      if (!isErrorQuestion.value) {
        console.log("questionsData", questionsData);
        // 看所有题目
        current_page.value = 1;
        subjectInfo.value = questionsData;
        total.value = Math.ceil(subjectInfo.value.length / 8);
        subjectInfoEight.length = 0;
        const startIndex = current_page.value * 8 - 8;
        const endIndex = current_page.value * 8;
        subjectInfoEight.push(...subjectInfo.value.slice(startIndex, endIndex));
        console.log("false---->subjectInfoEight", subjectInfoEight);
      } else {
        current_page.value = 1;
        // 只看错题
        const values = subjectInfo.value.filter((item: any) => {
          if (item.AnswerIsSuccess === false) {
            return item;
          }
        });
        subjectInfo.value = values;
        total.value = Math.ceil(subjectInfo.value.length / 8);
        subjectInfoEight.length = 0;
        const startIndex = current_page.value * 8 - 8;
        const endIndex = current_page.value * 8;
        subjectInfoEight.push(...subjectInfo.value.slice(startIndex, endIndex));
        console.log("true---->subjectInfoEight", subjectInfoEight);
      }
    };
    const goToSubject = (data: any) => {
      store.commit(
        MutationNames.CHANGE_FREEPRACTICERECORDSUBJECTDATA,
        subjectInfo.value
      );
      router.push({
        path: "/freePracticeRecordSubject",
        query: {
          subjectData: data,
          isErrorQuestionType: isErrorQuestion.value.toString(),
        },
      });
    };
    // 下一页
    const next = () => {
      if (current_page.value >= total.value) {
        message.value = "已经是最后一页";
        ElMessage.warning({
          offset: 100,
          message: message.value,
          type: "warning",
        });
      } else {
        current_page.value++;
        subjectInfoEight.length = 0;
        const startIndex = current_page.value * 8 - 8;
        const endIndex = current_page.value * 8;
        subjectInfoEight.push(...subjectInfo.value.slice(startIndex, endIndex));
      }
    };
    // 上一页
    const previous = () => {
      if (current_page.value === 1) {
        message.value = "已经是第一页";
        ElMessage.warning({
          offset: 100,
          message: message.value,
          type: "warning",
        });
      } else {
        current_page.value--;
        subjectInfoEight.length = 0;
        const startIndex = current_page.value * 8 - 8;
        const endIndex = current_page.value * 8;
        subjectInfoEight.push(...subjectInfo.value.slice(startIndex, endIndex));
      }
    };
    onBeforeMount(async () => {
      console.log("route", route.query.isErrorQuestionType);
      console.log("isErrorQuestion", isErrorQuestion.value);
      if (route.query.isErrorQuestionType) {
        console.log("isErrorQuestionType11", route.query.isErrorQuestionType);
        if (route.query.isErrorQuestionType === "true") {
          console.log(1);
          isErrorQuestion.value = true;
        } else {
          console.log(2);
          isErrorQuestion.value = false;
        }
        checkIsErrorQuestion();
      } else {
        total.value = Math.ceil(subjectInfo.value.length / 8);
        subjectInfoEight.push(...subjectInfo.value.slice(0, 8));
      }
    });
    onMounted(async () => {
      await nextTick();
    });

    return {
      subjectInfo,
      subjectInfoEight,
      questionsData,
      current_page,
      total,
      questionType,
      isErrorQuestion,
      checkIsErrorQuestion,
      goBack,
      goToSubject,
      next,
      previous,
    };
  },
});
